<template>
  <main class="w-full flex-grow p-6">
    <button
      @click="showModal('insert', null)"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Add New Category Promo
    </button>

    <div class="mt-2 mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Options</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in rows"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{ index + 1 }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.promotion_category_name }}
              </span>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button
                  class=""
                  type="button"
                  @click="showModal('update', sos)"
                >
                  <fas icon="pencil-alt" class="text-app-default text-xl" />
                </button>
                <button
                  class=""
                  type="button"
                  @click="showModalDestroy(sos.id)"
                >
                  <fas icon="trash-alt" class="text-red-600 text-xl" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- modal -->
    <div
      v-if="modalCategory"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 500px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">{{ title }}</div>
            <div class="">
              <button @click.self="closeModal" class="font-3xl font-bold p-6">
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="flex flex-wrap">
              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Category Name</label
                >
                <input
                  v-model="promotion_category_name"
                  @keyup="promoCategoryNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.promotion_category_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Category Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.promotion_category_name_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModal"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                @click.self="handleSave"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModal"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- Modal destroy -->
    <div
      v-if="modalDestroy"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Warning !</div>
            <div class="">
              <button
                @click.self="closeModalDestroy"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            Are You Sure To Continue Delete This Category
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalDestroy"
                type="button"
                class="bg-green-400 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <button
                @click="deleteCategoryTenant"
                type="button"
                class="bg-red-500 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ deleteButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalDestroy"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Warning />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import SuccessNotif from "../../components/SuccessNotif.vue";
import Warning from "../../components/Warning.vue";
export default {
  name: "Table",
  components: {
    Warning,
    SuccessNotif,
  },
  data() {
    return {
      modalDestroy: false,
      modalCategory: false,
      title: "",
      actionType: null,
      promotion_category_name: "",
      errors: {
        promotion_category_name: false,
        promotion_category_name_msg: "",
      },
      rows: [],
      id: null,
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    promoCategoryNameChange: function(e) {
      this.promotion_category_name = e.target.value;
      this.errors.promotion_category_name = false;
      this.errors.promotion_category_name_msg = "";
    },
    showModalDestroy: function(id) {
      this.id = id;
      this.modalDestroy = true;
    },
    closeModalDestroy: function() {
      this.id = null;
      this.modalDestroy = false;
    },
    showModal: function(type, val) {
      if (type === "update") {
        this.id = val.id;
        this.promotion_category_name = val.promotion_category_name;
        this.sosmed_link = val.sosmed_link;
        this.title = "Update Category";
        this.actionType = "update";
      }
      if (type === "insert") {
        this.actionType = "insert";
        this.promotion_category_name = "";
        this.sosmed_link = "";
        this.title = "Create New Category";
      }
      this.modalCategory = true;
    },
    closeModal: function() {
      this.modalCategory = false;
    },
    findCategoryPromo: async function() {
      try {
        let res = await fetch(`${API}v1/promotion-categories`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.rows = respon.data;
        this.totalRecordCount = respon.data.length;
      } catch (err) {
        this._error("internal server error");
      }
    },
    handleSave: function() {
      if (this.actionType === "update") {
        this.updateCategory();
      }
      if (this.actionType === "insert") {
        this.saveCategory();
      }
    },
    saveCategory: async function() {
      this.saveButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/promo/category/store`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            promotion_category_name: this.promotion_category_name,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "promotion_category_name") {
                this.errors.promotion_category_name = true;
                this.errors.promotion_category_name_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          this.modalCategory = false;
          this._error(response.message);
          return;
        }
        this.modalCategory = false;
        this.saveButton = "Save";
        this.findCategoryPromo();
        this._success("Data has been saved.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    updateCategory: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("image", this.image);
      formdata.append("id", this.id);
      formdata.append("promotion_category_name", this.promotion_category_name);
      formdata.append("sosmed_link", this.sosmed_link);
      try {
        let res = await fetch(`${API}v1/admin/cms/promo/category/update`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.id,
            promotion_category_name: this.promotion_category_name,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "promotion_category_name") {
                this.errors.promotion_category_name = true;
                this.errors.promotion_category_name_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          this.modalCategory = false;
          this._error(response.message);
          return;
        }
        this.saveButton = "Save";
        this.modalCategory = false;
        this.findCategoryPromo();
        this._success("Data updated.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    deleteCategoryTenant: async function() {
      this.deleteButton = "Loading...";
      try {
        let res = await fetch(`${API}v1/admin/cms/promo/category/delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify({
            id: this.id,
          }),
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.deleteButton = "Delete";
          this.modalDestroy = false;
          this._error(response.message);
          return;
        }
        this.modalDestroy = false;
        this.deleteButton = "Delete";
        this.findCategoryPromo();
        this._success("Data deleted.");
      } catch (err) {
        this.deleteButton = "Delete";
        this.modalDestroy = false;
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findCategoryPromo();
  },
};
</script>
